// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"2e67d459","602":"510e73aa"}[chunkId] + ".chunk.css";
};